import * as React from "react";
import TitleWithValue from "../../title-with-value";

interface IFinancialDetailItemProps {
  title: string;
  value: string | number | React.ReactNode;
  direction?: "row" | "column" | "row-reverse" | "column-reverse" | any;
  alignItems?:
  | "flex-end"
  | "flex-start"
  | "center"
  | "space-between"
  | ("flex-end" | "flex-start" | "center" | "space-between")[];
}

const FinancialDetailItem: React.FunctionComponent<
  IFinancialDetailItemProps
> = ({ title, value, direction, alignItems }) => {
  return (
    <TitleWithValue
      title={title}
      variantValue={"smallMedium"}
      hasDoubleDot={true}
      value={value}
      justifyContent={"space-between"}
      direction={direction}
      alignItems={alignItems}
    />
  );
};

export default FinancialDetailItem;
